<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('emailTemplate.title') }}
    document-request-selector(
      v-model="documentRequest",
      :currentValues="{applicableOn: instance.entityType, externalId: instance.documentRequestExternalId}",
      :multiple="false",
      @input="setDocumentRequest"
    )
    v-row
      v-col(cols="6")
          v-text-field(
            v-model="instance.entityExternalId",
            :label="$t('Common.entityExternalId')",
          )
      v-col(cols="6")
          v-text-field(
            v-model="instance.clientId",
            :label="$t('Common.ClientId')",
          )
    code-editor(
      v-model="instance.body",
      language="htmlemmbedded"
    )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>
import DocumentRequestSelector from '@/components/ActionTemplate/DocumentRequestSelector';

export default {
  props: ['value', 'attachReport'],
  components: { DocumentRequestSelector },
  data: function ()  {
    return {
      initObject: {
        type: 'CALL LABELING SERVICE',
        body: '',
        isRazor: true,
        entityType: 'Shipment',
        clientId: 'SCO_THALES',
        entityExternalId: '@Model.ExternalId',
        documentRequestExternalId: ''
      },
      documentRequest: null,
      instance: {
        documentRequestExternalId: null,
        entityType: "Shipment"
      },
    }
  },
  computed: {
  },
  watch: {
    instance: {
      immediate: false,
      deep: true,
      handler(val) {
        //update values before emit
        if(val)
        {
          val.body = this.instance.body;
          val.entityType = this.instance.entityType;
          val.documentRequestExternalId = this.instance.documentRequestExternalId
          val.entityExternalId = this.instance.entityExternalId;
          delete this.instance.attachments;
        }

        this.$emit('input', val)
      },
    },
  },
  methods: {
    setDocumentRequest(v) {
      this.instance.entityType = v.applicableOn;
      this.instance.documentRequestExternalId = v.externalId;
    }
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
